<template>
  <ion-page>
    <ion-header :translucent="true">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-menu-button color="primary"></ion-menu-button>
        </ion-buttons>
        <ion-title>{{ $route.meta.title }}</ion-title>
      </ion-toolbar>
    </ion-header>
    
    <ion-content :fullscreen="true">
      <ion-header collapse="condense">
        <ion-toolbar>
          <ion-title size="large">{{ $route.meta.title }}</ion-title>
        </ion-toolbar>
      </ion-header>
    
      <div id="container">
        <div style="margin-left: 24px;margin-right: 24px;">

        <div class="barra-filtros">
          <div class="filtro-buscar">
            <ion-icon :icon="searchOutline" class="filtro-buscar-icono" aria-hidden="true"></ion-icon>
            <input
              type="text"
              v-model="search"
              @input="buscarDebounce"
              placeholder="Buscar por expediente, cliente, DNI…"
            />
          </div>

          <select class="filtro-select" v-model="status" @change="filtrar">
            <option value="">Todos los estados</option>
            <option value="true">No leído</option>
            <option value="false">Leído</option>
          </select>

          <select class="filtro-select" v-model="colaborador_id" @change="filtrar">
            <option value="">Todos los colaboradores</option>
            <option
              v-for="colaborador in colaboradores"
              :value="colaborador.id"
              :key="colaborador.id"
            >
              {{ colaborador.name == null ? colaborador.user_name : colaborador.name }}
            </option>
          </select>

          <span class="filtro-espacio"></span>

          <button
            v-if="getUser?.role?.name == 'Colaborador' || getUser?.role?.name == 'Despacho'"
            class="btn-nuevo"
            @click="openModalAdd"
          >
            + Nuevo siniestro
          </button>
        </div>

        <div class="card">
            <table class="table table-responsive-sm table-striped table-align-middle">
              <thead>
                <tr>
                  <th @click="setSort('siniestros.expediente')">
                    Nro. expediente 
                    <ion-icon v-if="sort_active && sort == 'siniestros.expediente' && order == 'asc'" :icon="arrowUpOutline"></ion-icon>
                    <ion-icon v-if="sort_active && sort == 'siniestros.expediente' && order == 'desc'" :icon="arrowDownOutline"></ion-icon> 
                  </th>

                  <th @click="setSort('users.user_name')">
                    Colaborador
                    <ion-icon v-if="sort_active && sort == 'users.user_name' && order == 'asc'" :icon="arrowUpOutline"></ion-icon>
                    <ion-icon v-if="sort_active && sort == 'users.user_name' && order == 'desc'" :icon="arrowDownOutline"></ion-icon> 
                  </th>

                  <th style="width: 300px;">Clientes</th>
                  <th @click="setSort('siniestros.created_at')">
                    Fecha de registro
                    <ion-icon v-if="sort_active && sort == 'siniestros.created_at' && order == 'asc'" :icon="arrowUpOutline"></ion-icon>
                    <ion-icon v-if="sort_active && sort == 'siniestros.created_at' && order == 'desc'" :icon="arrowDownOutline"></ion-icon> 
                  </th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <DataSiniestro :siniestros="siniestros" @reload="getUser.role.name != 'Administrador' ? getSiniestrosSearchByUser() : getSiniestrosSearch()"/>
              
            </table>
            <Paginate :data="siniestros" @page="page($event)"/>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>

import { 
  defineComponent 
} from 'vue';
import {
  arrowDownOutline,
  arrowUpOutline,
  searchOutline
} from 'ionicons/icons';
import { 
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar
} from '@ionic/vue';
import { 
  modalController,
  createAnimation,
  alertController 
} from '@ionic/vue';
import { 
  mapGetters 
} from "vuex";
import toast from '@/plugins/toast'
import axios from 'axios'
import agregarSiniestro from './agregarSiniestro';
import DataSiniestro from '@/components/DataSiniestro'
import Paginate from '@/components/Paginate'

export default defineComponent({
  name: 'FolderPage',
  components: {
    IonButtons,
    IonContent,
    IonHeader,
    IonMenuButton,
    IonPage,
    IonTitle,
    IonToolbar,
    DataSiniestro,
    Paginate
  },
  computed: {
    ...mapGetters([
        'getUser'
    ]),
  },
  setup() {
    return { arrowDownOutline, arrowUpOutline, searchOutline }
  },
  data(){
    return {
      localStorage: 'page_siniestro_reclasin',
      siniestros : [],
      colaboradores: [],
      colaborador_id: '',
      sort: '',
      sort_prev: null,
      sort_active : false,
      order: 'desc',
      search: '' ,
      status: ''
    }
  },
  mounted(){
    this.getColaboradoresByUser()
    this.getUser.role.name != 'Administrador' ? 
      this.getSiniestrosByUser() : 
      this.getSiniestros();
  },
  methods:{
    setSort(column){
      this.sort = column
      this.sort_active = true

      if (this.sort == column) {
        if(this.sort_prev == column)
          this.order == 'asc' ? this.order = 'desc' : this.order = 'asc'
      }else{
        this.sort = column
      }
      this.sort_prev = column
      
      this.getUser.role.name != 'Administrador' ? 
        this.getSiniestrosSearchByUser() : 
        this.getSiniestrosSearch();
    },
    getSiniestros(){
      axios.get('/api/siniestros?finalizado=0')
      .then(res => {
        console.log(res.data.data)
        this.siniestros = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    getSiniestrosSearch(){
      axios.get('/api/siniestros?finalizado=0&search='+this.search+'&columnOrderBy='+this.sort+'&orderBy='+this.order+'&status='+this.status+'&colaborador_id='+this.colaborador_id)
      .then(res => {
        console.log(res.data.data)
        this.siniestros = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    getSiniestrosByUser(){
      axios.get('/api/siniestros/by/user?finalizado=0')
      .then(res => {
        console.log(res.data.data)
        this.siniestros = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    getSiniestrosSearchByUser(){
      axios.get('/api/siniestros/by/user?finalizado=0&search='+this.search+'&columnOrderBy='+this.sort+'&orderBy='+this.order+'&status='+this.status+'&colaborador_id='+this.colaborador_id)
      .then(res => {
        console.log(res.data.data)
        this.siniestros = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    filtrar(){
      // Consciente del rol: el Administrador ve todos los siniestros, el resto
      // solo los de su ámbito. Antes la búsqueda/filtros llamaban siempre a la
      // vía "byUser", con lo que al admin le salía vacío.
      this.getUser.role.name != 'Administrador'
        ? this.getSiniestrosSearchByUser()
        : this.getSiniestrosSearch();
    },
    buscarDebounce(){
      clearTimeout(this._buscarTimer);
      this._buscarTimer = setTimeout(() => this.filtrar(), 500);
    },
    getColaboradoresByUser(){
       axios.get('/api/users/colaborador/byUser?all=true')
      .then(res => {
        console.log(res.data.data)
        this.colaboradores = res.data.data
      })
      .catch(error => {
        console.log(error)
      })
    },
    getParameterByName(name, url = window.location.href) {
      // eslint-disable-next-line
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    page(url){
    
      if (url == null) {
        return;
      }

      //var page = this.getParameterByName("page",url);

      axios.get(url+'&finalizado=0&search='+this.search+'&columnOrderBy='+this.sort+'&orderBy='+this.order+'&status='+this.status+'&colaborador_id='+this.colaborador_id)
       .then(res => {
         this.siniestros = res.data.data;
       })
       .catch(error => {
        console.log(error);
      });
    },
     async openModalAdd() {
      
      const modal = await modalController
        .create({
          component: agregarSiniestro,
          cssClass: 'class-modal-siniestro',
          keyboardClose : true,
        })
      
      modal.present();

      modal.onDidDismiss().then((data) => {
        console.log(data)
        if(data.data == 'reload'){
          this.getUser.role.name != 'Administrador' ? 
            this.getSiniestrosByUser() : 
            this.getSiniestros();
        }
      })
    },

    showNota(siniestro){
      //location.href = 'chat/'+siniestro.chat.id+'?siniestro_id='+siniestro.id
      window.open('chat/'+siniestro.chat.id+'?siniestro_id='+siniestro.id, "Notas Siniestros "+siniestro.expediente, "width=800, height=800")
    },
    showDocumentos(siniestro_id){
      //this.$router.push({ name: 'documentos' , params : {siniestro_id : siniestro_id}})
      window.open('documentos/'+siniestro_id, "Documentos Siniestros ", "width=800, height=800")
    },
    async eliminarSiniestroConfirmacion(siniestro) {

        const alert = await alertController.create({
          cssClass: 'my-custom-class',
          header: '¡Confirmación!',
          message: '¿Realmente desea eliminar este siniestro?',
          buttons: [
            {
              text: 'Cancelar',
              role: 'cancel',
              cssClass: 'secondary',
              handler: (blah) => {
                console.log('Confirm Cancel:', blah);
              },
            },
            {
              text: 'Eliminar',
              handler: async () => {
                var loading = await toast.showLoading()

                await loading.present();
                
                console.log('Confirm Okay');
                
                axios.delete('/api/siniestros/'+siniestro.id)
                .then(data =>{
                  toast.openToast("Siniestro eliminado exitosamente","error",2000)
                  loading.dismiss()
                  this.getUser.role.name != 'Administrador' ? this.getSiniestrosByUser() : this.getSiniestros();
                  console.log(data)

                }).catch(err =>{
                  loading.dismiss()
                  console.log(err)
                })
              },
            },
          ],
        });
        return alert.present();
      },
   
     enterAnimation : function () {
      let baseEl = document
        const backdropAnimation = createAnimation()
        .addElement(baseEl.querySelector('ion-backdrop'))
        .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

      const wrapperAnimation = createAnimation()
        .addElement(baseEl.querySelector('.modal-wrapper'))
        .keyframes([
          { offset: 0, opacity: '0', transform: 'scale(0)' },
          { offset: 1, opacity: '0.99', transform: 'scale(1)' }
        ]);

      return createAnimation()
            .addElement(baseEl)
            .easing('ease-out')
            .duration(500)
            .addAnimation([backdropAnimation, wrapperAnimation]);
    },
    leaveAnimation  : function () {
       return this.enterAnimation(document).direction('reverse');
    },
  }
});
</script>

<style scoped>

ion-label {
  font-weight: bold;
}

ion-input {
  background: rgba(63,81,181,.15);
  border-radius: 20px;
  padding: 5px 8px !important;
  margin: 10px 0;
}

ion-button {
  width: auto;
  --border-radius: 5px;
  height: 35px;
  text-transform: none;
}

.input-text{
  margin-bottom: 15px;
  padding-left: 17px;
  background: #F5F5F5;
  border: 1px solid rgba(183, 183, 183, 0.3);
  box-sizing: border-box;
  border-radius: 24px;
  width :90%;
  height : 48px;
}

/* ---- Barra de filtros ---- */
.barra-filtros {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 4px;
}

.filtro-buscar {
  position: relative;
  flex: 1 1 280px;
  min-width: 220px;
}

.filtro-buscar-icono {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  font-size: 18px;
  pointer-events: none;
}

.filtro-buscar input {
  width: 100%;
  height: 42px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  padding: 0 12px 0 38px;
  font-size: 14px;
  color: #0f172a;
  box-sizing: border-box;
}

.filtro-select {
  height: 42px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #ffffff;
  padding: 0 34px 0 12px;
  font-size: 14px;
  color: #0f172a;
  cursor: pointer;
  min-width: 170px;
  appearance: none;
  -webkit-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.filtro-buscar input:focus,
.filtro-select:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.filtro-espacio {
  flex: 1 1 auto;
}

.btn-nuevo {
  height: 42px;
  border: none;
  border-radius: 10px;
  background: #1e293b;
  color: #ffffff;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease;
}

.btn-nuevo:hover {
  background: #0f172a;
}


</style>